// Approve Team Level module (temporary mock)
// action types
import ApiService from "../../api.service";
import {SET_ERROR} from "../auth.module";

export const GET_DOMAIN_REVIEW_LIST = "level-approval-request/list";
export const GET_PROGRESS_LEADER_LIST = "level-approval-request/progress-level-teamlead";
export const GET_PROGRESS_STAFF_LIST = "level-approval-request/progress-level-staff";
export const GET_PROGRESS_LIST = "level-approval-request/current-level";
export const GET_LIST_LEVEL = "level-approval-request/list-level";

const state = {
};

const getters = {
};

const actions = {
    [GET_DOMAIN_REVIEW_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_DOMAIN_REVIEW_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_DOMAIN_REVIEW_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_DOMAIN_REVIEW_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },


    [GET_PROGRESS_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_PROGRESS_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_PROGRESS_LEADER_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_PROGRESS_LEADER_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_PROGRESS_STAFF_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_PROGRESS_STAFF_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_LIST_LEVEL](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_LIST_LEVEL}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
};

const mutations = {
};

export default {
    state,
    actions,
    mutations,
    getters,
};


